module.exports = __webpack_public_path__ + "img/Logo-19.321936b6.svg";